import { TSide } from "../utils/types/gui/field.types";

export const generateSide = (
  type: "margin" | "padding" | "position",
  value?: TSide
) => {
  if (!value || Object.keys(value).length === 0) return 0;

  if (type === "position") {
    const positions = {};

    Object.keys(value).forEach((key) => {
      const data: string = value[key];

      positions[key.toLowerCase()] = data.includes("auto") ? "auto" : data;
    });

    return positions;
  } else {
    const { Top, Right, Bottom, Left } = value;

    const top = Top ? (Top.includes("auto") ? "auto" : Top) : 0;
    const right = Right ? (Right.includes("auto") ? "auto" : Right) : 0;
    const bottom = Bottom ? (Bottom.includes("auto") ? "auto" : Bottom) : 0;
    const left = Left ? (Left.includes("auto") ? "auto" : Left) : 0;

    if (top === right && right === bottom && bottom === left) {
      return top;
    } else if (top === bottom && left === right) {
      return `${top} ${right}`;
    }

    return `${top} ${right} ${bottom} ${left}`;
  }
};
